import {
  assignStudentMockHandler,
  getAvailableBatchesMockHandler,
  joinWaitlistMockHandler,
} from '@/features/batch-selection/api';

export const batchSelectionHandlers = [
  getAvailableBatchesMockHandler,
  assignStudentMockHandler,
  joinWaitlistMockHandler,
];
